import { ReactElement } from 'react';

export enum TooltipPlacement {
    'top',
    'bottom-end',
    'bottom-start',
    'bottom',
    'left-end',
    'left-start',
    'left',
    'right-end',
    'right-start',
    'right',
    'top-end',
    'top-start'
}

export enum TooltipTypesName {
    'primary',
    'secondary',
    'purple'
}

export interface TooltipContainerProps {
    title: ReactElement | string;
    children: ReactElement;
    hasDefaultStyle?: boolean;
    classes?: object;
    placement?: keyof typeof TooltipPlacement;
    arrow?: boolean;
    titleClassName?: string;
    dataTestid?: string;
    open?: boolean;
    interactive?: boolean;
    enterDelay?: boolean;
    maxWidth?: string;
    minWidth?: string;
    type?: keyof typeof TooltipTypesName;
    extraclasses?: object;
    popperStyle?: object;
    disablePortal?: boolean;
}

export const tooltipType = {
    primary: {
        backgroundColor: '#070019 !important',
        color: '#e1e1e1cc !important',
        fontSize: '0.825rem !important',
        border: '1px solid #c26991e6'
    },
    secondary: {
        backgroundColor: 'white !important',
        color: '#626262 !important',
        fontSize: '0.8125rem !important',
        border: '1px solid #E2D8F7',
        padding: '0.375rem 0.5rem'
    },
    purple: {
        backgroundColor: '#716596 !important',
        color: '#F2EFF8E5 !important',
        fontSize: '0.8125rem !important',
        border: '1px solid #F2EFF8',
        padding: '0.375rem 0.5rem'
    }
};
